import React from "react";
import styled from "styled-components";

const TooltipContainer = styled.div`
  position: absolute;
  left: ${({ $tooltip }) => $tooltip.x.toFixed(0) + "px"};
  top: ${({ $tooltip }) => $tooltip.y.toFixed(0) + "px"};
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 15px 20px;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  z-index: 1000;
  transform: translateX(-50%); // 중앙 정렬
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  cursor: pointer;

  .point-index {
    font-size: 18px;
    font-weight: 700;
    margin: 0;
  }
  .point-value {
    font-size: 14px;
    margin: 0;
  }
`;
export default function Tooltip({ tooltip, setTooltip, deletePonint }) {
  const closeTooltip = () => {
    setTooltip({
      visible: false,
      x: 0,
      y: 0,
      content: null,
      pointPosition: null,
    });
  };
  return (
    <TooltipContainer
      $tooltip={tooltip}
      onClick={() => {
        closeTooltip();
      }}
    >
      <h2 className="point-index">포인트 {tooltip.content.index}</h2>
      <div className="point-value">위도: {tooltip.content.latitude}°</div>
      <div className="point-value">경도: {tooltip.content.longitude}°</div>
      <button onClick={() => deletePonint(tooltip.content.index)}>삭제</button>
    </TooltipContainer>
  );
}
